import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";

const ChartZoomOut = ({id = undefined, className = undefined, sx = {}, color = "primary", onClick}) => {
  const {t} = useTranslation();

  return (
    <Tooltip title={t("components.chart.zoomOut.title")}>
      <IconButton
        id={id}
        className={className}
        sx={sx}
        aria-label={t("components.chart.zoomOut.label")}
        onClick={onClick}
      >
        <ZoomOutIcon color={color} />
      </IconButton>
    </Tooltip>
  );
};

export default ChartZoomOut;
